<h1 l10nTranslate>shared.areYouStillThere</h1>
<p l10nTranslate>shared.logoutSessionAutomatically</p>
<button mat-flat-button color="primary" id="e2e-tracking" (click)="continue()" l10nTranslate>shared.yes</button>
